import { request } from '../../../../..';
import { IInsiderBrandsResponse } from '../../../../../indigofair/data/IInsiderBrandsResponse';
import {
  EndpointOptions,
  RequestOptions,
  SuccessResponse,
  PATH,
} from '../../../../../types';
import qs from 'query-string';

export type QueryParameters = {
  num_brands: number | undefined;
};

export namespace QueryParameters {
  export const build = (partial: Partial<QueryParameters>): QueryParameters =>
    partial as QueryParameters;
}

export const path = (queryParams?: QueryParameters) => {
  const queryString = queryParams ? `?${qs.stringify(queryParams)}` : '';
  return `/api/retailer/insider/brands/carousel${queryString}`;
};

export const build = (
  queryParams?: QueryParameters,
  options?: EndpointOptions
): RequestOptions & { route: string } => {
  return {
    route,
    url: path(),
    method: 'GET',
    params: queryParams,
    ...options,
  };
};
/**
 * path-to-regexp definition of this endpoint's route
 */
export const route = '/api/retailer/insider/brands/carousel';

/**
 * Returns brands that is eligible for insider discount according to the Universal Framework ordering
 * https:www.notion.so/faire/Rest-of-Europe-RoE-Insider-Launch-ddff75eff27543118e33da1d87f69b4a
 * Product Area: INSIDER
 */
export function execute(
  queryParams?: QueryParameters
): Promise<IInsiderBrandsResponse>;
export function execute(
  queryParams?: QueryParameters,
  options?: EndpointOptions & { rawResponse: true }
): Promise<SuccessResponse<IInsiderBrandsResponse>>;
export function execute(
  queryParams?: QueryParameters,
  options?: EndpointOptions
): Promise<IInsiderBrandsResponse>;
export function execute(
  queryParams?: QueryParameters,
  options?: EndpointOptions
): Promise<IInsiderBrandsResponse | SuccessResponse<IInsiderBrandsResponse>> {
  const { route, ...requestOptions } = build(queryParams, options);
  return request<IInsiderBrandsResponse>(requestOptions);
}
execute[PATH] = 'api/retailer/insider/brands/carousel/get';
export default execute;
